<template>
  <b-container>
  <b-row class="mt-4">
      <b-col>
        <Navigation
          targetPageValue="BuildingList"
          :targetPageName="$t('title.buildingManagement')"
          v-on:changePage="setNextPage"
        />
      </b-col>
    </b-row>
  <h1 class="text-center pt-4 pb-4">{{ $t("action.addBuilding") }}</h1>
  <b-form @submit="onSubmit">

      <b-row class="mt-2">
        <b-col sm class="mt-4">
          <b-form-select v-model="form.building" :options="buildings" multiple :select-size="8"></b-form-select>  
          <div class="text-danger" v-if="!$v.form.building.required && $v.form.building.$dirty">{{ $t("info.required") }}</div>
        </b-col>         
      </b-row>
    
    <b-button class="mt-4" type="submit" variant="success" :disabled="disabled">{{ $t("action.submit") }}</b-button>
    
  </b-form>

  <div v-if="spinner" class="text-center pt-2">
      <b-spinner style="width: 3rem; height: 3rem;" variant="success" label="Spinning" disabled="labelStatus"></b-spinner>
  </div>

  <div v-if="error" class="pt-4">
      <b-alert show variant="danger">
        <p>{{ error }}</p>
      </b-alert>
  </div>

</b-container>
</template>

<script>
import axios from 'axios';
import { mappBuildingDataForSelect} from '../../assets/Utils.js';
import { required } from 'vuelidate/lib/validators';
import { globalF } from '../Helpers';
import Navigation from '../Navigation.vue';

export default {
mixins: [globalF],
  data() {
    return {
      form: {
        building: []          
      },
      error: "",
      disabled: false,
      spinner: false
    }
  },
validations() {
      return {
        form: {
          building: {
            required
          }
        }
      }
},
mounted () {

},
computed: {
 buildings: function () {
    let buildings = this.getGlobalData("buildings");  
    let userBuilding = this.$store.getters.getBuildingToEdit;
    let res = [];
    let newList = [];
    if (buildings) {
      buildings.sort(function (a,b) {
        if(a.NOMDIV < b.NOMDIV) { return -1; }
        if(a.NOMDIV > b.NOMDIV) { return 1; }
        return 0;
      });
        res = mappBuildingDataForSelect(buildings);    
        for (let i=0; i < res.length; i++) {
            let found = userBuilding.findIndex(r => r.Id === res[i].value.Id);
            if (found === -1) {
                newList.push(res[i]);
            }
        }
    }
    
    return newList;
    },
  url: function () {
    let urls = this.$store.getters.getUrlsList;
    return urls[process.env.VUE_APP_WHERE].json;
  }
 },
methods:{    
    onSubmit(evt) {
      evt.preventDefault();
      this.emailexist = false;
      this.error = "";
      this.$v.$touch();
        if (!this.$v.$invalid) {
           /*Ajax Call*/
          this.spinner = true;
          let user = this.$store.getters.getUserToEdit;
          this.form.IdUser = user.Id;

          let promise = this.validateToken();  
          promise.then(() => {
            axios.post(this.url, {request: "addBuildingForUser", form: this.form }, { headers: {'Content-Type': 'application/json'}})
            .then(()  => {
              this.spinner = false;
              this.resetField();
              this.$emit('changePage', 'UserList');
            })
            .catch(()  => {
              this.spinner = false;
              this.error = this.$t('info.errorgeneric');
              this.disabled = false;
            });

          });
        }
    },  
    resetField: function () {
      this.$v.$reset();
      this.form.fname = '';
      this.form.lname = '';     
      this.form.building = [];
      this.form.role = null;
      this.existingUser = false;
    },
    setNextPage(page) {
          this.$emit('changePage', page);
    }
  },
  components: {
    Navigation
  },
}
</script>
